import $ from 'jquery'
import Cookies from 'js-cookie'
import axios from 'axios'
import qs from 'qs'
const TokenKey = config.TokenKey ? config.TokenKey : 'RedCoral_loginuserkey_2018';
let i = 0;
let j = 0;

// let loginUser = {
//   userId: '48', //28
//   ContactID: '7',
//   enCode: null,
//   account: '100666', //100028
//   password: 666666,
//   secretkey: null,
//   realName: '刘婷婷', //许跃林
//   nickName: null,
//   headIcon: null,
//   gender: null,
//   mobile: null,
//   telephone: null,
//   email: null,
//   oICQ: null,
//   weChat: null,
//   companyId: '1',
//   companyName: '安徽医科大学第一附属医院',
//   companyIds: null,
//   departmentId: '100101',
//   departmentName: '心血管内科',
//   departmentIds: null,
//   openId: null,
//   roleIds: '1,11,12,13,14,2,3',
//   postIds: '1,22,52',
//   organizationId: '1',
//   organizationName: '',
//   companyDeptIds: '7,6,5,4,2,3,7,8,14,9,10,1,12,1,15,13,4,11',
//   isSystem: false,
//   ReceptionIds: 'ed47b7ae48d0eb9c,ea067f3fb1182d6,ed16704de6992b2d,238c55e907cc4327',
//   appId: 'RedCoral_Web',
//   logTime: '2018-11-12 14:53:01',
//   iPAddress: '10.64.3.196',
//   iPAddressName: '本地局域网',
//   browser: 'Chrome 70.0',
//   loginMark: null,
//   token: '7D4BD5E019B255A77A43055CF04C45CA20E62FD2E0A248B6D64CFF8CA1D9AF9337D45DDE064F45A7',
//   imUrl: null
// }

let loginUser = {"userId":"144","enCode":null,"account":"499889652","password":null,"secretkey":null,"realName":"汪巧巧","nickName":null,"headIcon":null,"gender":null,"mobile":"13580376450","telephone":null,"email":null,"oICQ":null,"weChat":null,"companyId":null,"companyIds":null,"departmentId":"1","departmentName":"开发部","departmentIds":null,"openId":null,"roleIds":"1,2","postIds":"2","companyDeptIds":"7,6,5,4,3,2,3,21,17,7,23,19,8,14,9,22,18,24,20,16,16,10,26,9,10,1,25,12,8,1,17,20,19,15,15,13,6,4,12,5,11","IscompanyDept":true,"organizationId":"1","organizationName":"安徽医科大学第一附属医院","isSystem":false,"ReceptionIds":"f40ad95ab4ee3cf1","OrganizationCode":"234456232","ContactID":"5","appId":"RedCoral_Web","iPAddress":"117.71.55.7","iPAddressName":null,"browser":null,"loginMark":null,"token":"5274F6A1987B0C7846267F6C10F48D17BFD22B7AAA1923B07560A8BDF86D0ED2B7844C7CEE12234D","imUrl":null}

export function getToken() {
  let code = getUrlKey('code');
  let mac = getUrlKey('mac');
  if (process.env.NODE_ENV === 'production') {
    let userCookie = Cookies.get(TokenKey); //获取cookies
    if (isHome()) //判断根目录不需要登陆验证
    {
      if (userCookie !== undefined) {
        let user = JSON.parse(userCookie)
        // console.log('token',userCookie.token);
        Preloading(user)
        return user;
      } else {
        return {};
      }
    } else {
      if (userCookie !== undefined) {
        let user = JSON.parse(userCookie)
        // console.log('token',userCookie.token);
        Preloading(user)
        if (!code) {
          if (user.token !== null) {
            let token = localStorage.getItem('token')
            if (user.token !== token) {
              // Preloading(user)
            }
            return user
          }
        } else {
          if (user.account === code || user.mobile === code) {
            load();
            return user
          } else {
            return userlogin(code)
          }
        }
      } else {
        return userlogin(code)
      }
    }
  } else {
    let userCookie = Cookies.get(TokenKey) //获取cookies
    if (userCookie !== undefined) {
      let user = JSON.parse(userCookie)
      Preloading(user)
      if (code || mac) {
        load();
      }
      return user;
    } else {
      setToken(loginUser)
      // Preloading(loginUser)
    }
    return loginUser
  }
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, 24 * 60 * 60 * 1000)
}
export function Preloading(user) {
  //登陆后预加载相关常用数据
  if (j === 0) {
    j++
    let baseRepairURL = config.REPAIRAPI_ROOT;
    let token = localStorage.getItem('token');
    localStorage.setItem('token', user.token)

    if (config.Type != 1) {
      let FaultTypeOptions = localStorage.getItem('FaultTypeOptions')
      if (FaultTypeOptions == 'null' || !FaultTypeOptions || token != user.token) {
        axios({
            method: 'get',
            url: baseRepairURL + 'Task/GetAllEventReason',
            params: {
              //这里是发送给后台的数据
              type: 0
            }
          })
          .then(response => {
            // Vue.prototype.FightServerCenters = response.data;
            localStorage.setItem('FaultTypeOptions', JSON.stringify(response.data))
          })
          .catch(error => {
            console.log('请求', error) //请求失败返回的数据
          })
      }

      let AllServerCenter = localStorage.getItem('AllServerCenter')
      if (AllServerCenter == 'null' || !AllServerCenter || token != user.token) {
        axios({
            method: 'get',
            url: baseRepairURL + 'ServerDuty/GetAllServerCenterByUserId',
            params: {
              //这里是发送给后台的数据
              userId: user.userId
            }
          })
          .then(response => {
            // Vue.prototype.FightServerCenters = response.data;
            localStorage.setItem('AllServerCenter', JSON.stringify(response.data))
          })
          .catch(error => {
            console.log('请求', error) //请求失败返回的数据
          })
      }

      let TaskTypeView = localStorage.getItem('TaskTypeView')
      if (TaskTypeView == 'null' || !TaskTypeView || token != user.token) {
        axios({
            method: 'get',
            url: baseRepairURL + 'task/GetAllTaskTypeView',
          })
          .then(response => {
            localStorage.setItem('TaskTypeView', JSON.stringify(response.data))
            localStorage.setItem('DefaultTaskTypeView', JSON.stringify(response.data.filter(item => item.ISDEFAULT == true)))
          })
          .catch(error => {
            console.log('请求DefaultTaskTypeView', error) //请求失败返回的数据
          })
      }

      let TaskTypeByView = localStorage.getItem('TaskTypeByView')
      if (TaskTypeByView == 'null' || !TaskTypeByView || token != user.token) {
        axios({
            method: 'get',
            url: baseRepairURL + 'task/GetAllTaskTypeByView',
          })
          .then(response => {
            localStorage.setItem('TaskTypeByView', JSON.stringify(response.data))
          })
          .catch(error => {
            console.log('GetAllTaskTypeByView', error) //请求失败返回的数据
          })
      }

      //
      let FightServerCenters = localStorage.getItem('FightServerCenters')
      if (FightServerCenters == 'null' || !FightServerCenters || token != user.token) {
        axios({
            method: 'get',
            url: baseRepairURL + 'Task/getAcceptTaskServerCenters',
            params: {
              //这里是发送给后台的数据
              userId: user.userId
            }
          })
          .then(response => {
            // Vue.prototype.FightServerCenters = response.data;
            localStorage.setItem('FightServerCenters', JSON.stringify(response.data))
            // console.log('FightServerCenters', response.data)
          })
          .catch(error => {
            console.log('请求', error) //请求失败返回的数据
          })
      }

      //我管理的服务台
      let ManageServerCenter = localStorage.getItem('ManageServerCenter')
      if (ManageServerCenter == 'null' || !ManageServerCenter || token != user.token) {
        axios({
            method: 'get',
            url: baseRepairURL + 'Task/GetAllManageServerCenterByUserId',
            params: {
              userId: user.userId
            }
          })
          .then(response => {
            localStorage.setItem('ManageServerCenter', JSON.stringify(response.data))
            console.log('服务台1', response.data)
          })
          .catch(error => {
            console.log('请求', error) //请求失败返回的数据
          })
      }
    }

    setTaskType(user, false);
    //服务台客服
    let ServerCenterMember = localStorage.getItem('ServerCenterMember')
    if (ServerCenterMember == 'null' || !ServerCenterMember || token != user.token) {
      axios
        .post(
          baseRepairURL + 'Task/GetServerCenterByUserId',
          qs.stringify({
            ID: user.userId,
            NAME: '',
            DEPTID: '',
            DEPTNAME: '',
            COMPANYID: '',
            COMPANYNAME: ''
          })
        )
        .then(response => {
          console.log('ServerCenterMember', response.data)
          localStorage.setItem(
            'ServerCenterMember',
            JSON.stringify(
              response.data.map(function (item) {
                return item.SERVERCENTERID
              })
            )
          )
        })
        .catch(error => {
          console.log('GetServerCenterByUserId 请求', error) //请求失败返回的数据
        })
    }
  }
}

export function getUrlKey(name) {
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
        location.href
      ) || [, ''])[1].replace(/\+/g, '%20')
    ) || null
  )
}

//注销
export function removeToken() { //清除Token
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  if (userAgent.indexOf("Anybao") > -1) {
    CefSharp.BindObjectAsync("message").then(function (result) {
      message.Logout();
    });
  }

  return Cookies.remove(TokenKey)
}

export function login() {
  Cookies.set('cookieUrl', window.location.href, 24 * 60 * 60 * 1000)
  window.location.href = config ?
    config.Backstage_ROOT :
    process.env.Backstage_ROOT
}

export function isLogin() {
  let userCookie = Cookies.get(TokenKey) //获取cookies
  if (userCookie !== undefined) {
    return true;
  } else {
    return false;
  }
}

export function setTaskType(user, isLoad) {
  if (!user) {
    return false;
  }
  let token = localStorage.getItem('token');
  //任务类型
  let TaskType = localStorage.getItem('TaskType')
  // console.log('TaskType',TaskType);
  if (TaskType == 'null' || !TaskType || token != user.token || isLoad) {
    axios({
        method: 'get',
        url: config.REPAIRAPI_ROOT + 'Task/GetTaskTypeList',
        data: qs.stringify({
          //这里是发送给后台的数据
        })
      })
      .then(response => {
        localStorage.setItem('TaskType', JSON.stringify(response.data))
      })
      .catch(error => {
        console.log('请求', error) //请求失败返回的数据
      })
  }
}

function isHome() {
  // console.log('端口',window.location.port)
  // console.log('拼接',window.location.protocol+"//"+window.location.host);
  // console.log('当前url',window.location.href);
  // console.log('状态',window.location.protocol+"//"+window.location.host+'/#/'===window.location.href || window.location.protocol+"//"+window.location.host+'/'===window.location.href||window.location.protocol+"//"+window.location.host+'/task/#/'===window.location.href || window.location.protocol+"//"+window.location.host+'/task'===window.location.href);
  return (window.location.protocol + "//" + window.location.host + '/#/' === window.location.href || window.location.protocol + "//" + window.location.host + '/' === window.location.href || window.location.protocol + "//" + window.location.host + '/task/#/' === window.location.href || window.location.protocol + "//" + window.location.host + '/task' === window.location.href);
  // if(window.location.port){
  //   console.log('拼接',window.location.protocol+"//"+window.location.host+':'+window.location.port);
  //   console.log('当前url',window.location.href);
  //   return (window.location.protocol+"//"+window.location.host+':'+window.location.port+'/#/'===window.location.href || window.location.protocol+"//"+window.location.host+':'+window.location.port===window.location.href||window.location.protocol+"//"+window.location.host+':'+window.location.port+'/task/#/'===window.location.href || window.location.protocol+"//"+window.location.host+':'+window.location.port+'/task'===window.location.href);
  // }else{
  //   return (window.location.protocol+"//"+window.location.host+'/#/'===window.location.href || window.location.protocol+"//"+window.location.host===window.location.href||window.location.protocol+"//"+window.location.host+'/task/#/'===window.location.href || window.location.protocol+"//"+window.location.host+'/task'===window.location.href);
  // }
}

function isexit(str, arr) {
  let result = false
  for (let i = 0; i < arr.length; i++) {
    if (str.indexOf(arr[i]) != -1) {
      result = true
    }
  }
  console.log('isexit', result)
  return result
}
export async function userlogin(code) {
  let freeVerificationPath = [
    '/notificationReminder',
    '/usbApplication',
    '/usbAuthorization',
    '/usbAuthForMaintenance',
    '/notificationLookOver',
    "/LinkBook"
  ]
  // let config = {}
  // if (process.env.NODE_ENV === 'production') {
  //   $.ajax({
  //     url: 'serverconfig.json',
  //     type: 'get',
  //     dataType: 'json',
  //     async: false, //使用同步的方式,true为异步方式
  //     data: {}, //这里使用json对象
  //     success: function (data) {
  //       if (Array.isArray(data)) {
  //         if (isInnerIPFn()) {
  //           config = data[1]
  //         } else {
  //           config = data[0]
  //         }
  //       } else {
  //         config = data
  //       }
  //       localStorage.setItem('config', JSON.stringify(config))
  //     }
  //   })
  // }
  let mac = getUrlKey('mac')
  var url = window.location.href
  let noPath = [
    '/IMJobView',
    '/deviceNewPage',
    '/UserManage'
  ]

  if (!mac) {
    if (!isexit(url, noPath)) {
      if (!code) {
        if (isexit(url, freeVerificationPath)) {
          setToken(loginUser)
          return;
        } else {
          // Cookies.set('cookieUrl', window.location.href, 24 * 60 * 60 * 1000)
          // window.location.href = config ?
          //   config.Backstage_ROOT :
          //   process.env.Backstage_ROOT
          // return;
        }
      } else {
        let userCookie = Cookies.get(TokenKey) //获取cookies
        if (userCookie !== undefined) {
          let user = JSON.parse(userCookie)
          console.log('登录验证code:', code, user.account, user.mobile);
          if (user.account !== code && user.mobile !== code) {
            console.log('调整到登录页面并且传code');
            Cookies.set('cookieUrl', window.location.href, 24 * 60 * 60 * 1000)
            window.location.href = config ?
              config.Backstage_ROOT + '?code=' + code :
              process.env.Backstage_ROOT + '?code=' + code
            return;
          }
        } else {
          Cookies.set('cookieUrl', window.location.href, 24 * 60 * 60 * 1000)
          window.location.href = config ?
            config.Backstage_ROOT + '?code=' + code :
            process.env.Backstage_ROOT + '?code=' + code
          return;
        }
      }
    }
  }
  if (i === 0) {
    i++
    let apiurl = config ? config.API_ROOT : process.env.API_ROOT
    if (!apiurl) apiurl = '/newsapi/'
    let userInfo = {};
    $.ajax({
      url: apiurl + 'user/userLogin?code=' + code, // + '&mac=' + mac,
      type: 'get',
      async: false, //使用同步的方式,true为异步方式
      dataType: 'json',
      data: {}, //这里使用json对象
      success: function (data) {
        userInfo = data;
        if (!data.userId) {
          Cookies.set('cookieUrl', window.location.href, 24 * 60 * 60 * 1000)
          window.location.href = config ?
            config.Backstage_ROOT :
            process.env.Backstage_ROOT
        } else {
          console.log('userlogin_Token', data.token);
          setToken(data)
          Preloading(data) //预加载相关接口功能
          load();
        }
      },
      fail: function () {
        //code here...
      }
    })
    if (userInfo.userId) {
      if (userAgent.indexOf("Anybao") > -1) {
        await CefSharp.BindObjectAsync("message");
        message.Login(userInfo.userId);
      }
    }
    // alert(JSON.stringify( userLogin(code)));
    // return setTimeout(() => userLogin(code), 1000);
    // return new Promise((resolve, reject) => {
    //   await axios.get(this.API_ROOT+'user/userLogin?code='+code).then(res=>{
    //     // user=res.data;
    //     resolve(res.data)
    //   })
    // });
  }

  // userCookie = Cookies.get(TokenKey);//获取cookies
  // console.log(userCookie);
  return Cookies.get(TokenKey)
}

function load() {
  if (typeof jsObj == "undefined") {
    console.log('不在winfrom窗体内');
    let newUrl = funcUrlDel(['code', 'mac']);
    if (newUrl !== window.location.href) {
      window.location.href = newUrl
    }
  } else {
    console.log('winfrom窗体内');
  }
}

function funcUrlDel(nameArr) {
  var url = window.location.href
  let new_url = null;
  let index = url.indexOf('?');
  if (index == -1) {
    new_url = url
  } else {
    new_url = url.substring(0, url.indexOf('?'));
  }
  var query = url.split('?')[1];
  if (!query) {
    return url;
  }
  console.log('query', query);
  var obj = {}

  var arr = query.split("&");
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].split("=");
    obj[arr[i][0]] = arr[i][1];
  };
  console.log('参数数组1:', obj);
  nameArr.forEach(item => {
    if (query.indexOf(item) > -1) {
      delete obj[item];
    };
  });
  let pars = JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
  if (pars) {
    pars = "?" + pars;
  }
  var newurl = new_url + pars;
  return newurl
}

export function UrlDelPar(url, nameArr) {
  let new_url = null;
  let index = url.indexOf('?');
  if (index == -1) {
    new_url = url
  } else {
    new_url = url.substring(0, url.indexOf('?'));
  }
  var query = url.split('?')[1];
  if (!query) {
    return url;
  }
  console.log('query', query);
  var obj = {}

  var arr = query.split("&");
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].split("=");
    obj[arr[i][0]] = arr[i][1];
  };
  console.log('参数数组1:', obj);
  nameArr.forEach(item => {
    if (query.indexOf(item) > -1) {
      delete obj[item];
    };
  });
  console.log('参数数组', obj);
  console.log('参数', JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&"));
  let pars = JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
  if (pars) {
    pars = "?" + pars;
  }
  var newurl = new_url + pars;
  return newurl
}

export function isInnerIPFn() {
  // 获取当前页面url
  var curPageUrl = window.location.href;
  console.log('curPageUrl-0  ' + curPageUrl);

  var reg1 = /(http|ftp|https|www):\/\//g; //去掉前缀
  curPageUrl = curPageUrl.replace(reg1, '');
  // console.log('curPageUrl-1  '+curPageUrl);

  var reg2 = /\:+/g; //替换冒号为一点
  curPageUrl = curPageUrl.replace(reg2, '.');
  // console.log('curPageUrl-2  '+curPageUrl);

  curPageUrl = curPageUrl.split('.'); //通过一点来划分数组
  console.log(curPageUrl);


  var ipAddress = curPageUrl[0] + '.' + curPageUrl[1] + '.' + curPageUrl[2] + '.' + curPageUrl[3];

  var isInnerIp = false; //默认给定IP不是内网IP
  var ipNum = getIpNum(ipAddress);
  /**
   * 私有IP：A类  10.0.0.0    -10.255.255.255
   *       B类  172.16.0.0  -172.31.255.255
   *       C类  192.168.0.0 -192.168.255.255
   *       D类   127.0.0.0   -127.255.255.255(环回地址)
   **/
  var aBegin = getIpNum("10.0.0.0");
  var aEnd = getIpNum("10.255.255.255");
  var bBegin = getIpNum("172.16.0.0");
  var bEnd = getIpNum("172.31.255.255");
  var cBegin = getIpNum("192.168.0.0");
  var cEnd = getIpNum("192.168.255.255");
  var dBegin = getIpNum("127.0.0.0");
  var dEnd = getIpNum("127.255.255.255");
  isInnerIp = isInner(ipNum, aBegin, aEnd) || isInner(ipNum, bBegin, bEnd) || isInner(ipNum, cBegin, cEnd) || isInner(ipNum, dBegin, dEnd);
  console.log('是否是内网:' + isInnerIp);
  return isInnerIp;
}

function getIpNum(ipAddress) {
  /*获取IP数*/
  var ip = ipAddress.split(".");
  var a = parseInt(ip[0]);
  var b = parseInt(ip[1]);
  var c = parseInt(ip[2]);
  var d = parseInt(ip[3]);
  var ipNum = a * 256 * 256 * 256 + b * 256 * 256 + c * 256 + d;
  return ipNum;
}

function isInner(userIp, begin, end) {
  return (userIp >= begin) && (userIp <= end);
}

// export async function userLogin(code) {
//   const config = JSON.parse(localStorage.getItem('config'))
//   await axios.get((config ? config.API_ROOT : process.env.API_ROOT) + 'user/userLogin?code=' + code).then(res => {
//     userCookie = res.data;
//   })
//   return userCookie;
// }
// export default {
//   setTaskType
// }